export default {
    LOAD_CLOCK_APP(state, clock) {
        state.items = clock
    }
}